import { EventEmitter, Component, Input, Output, Injectable, ElementRef, NgModule } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { SettingsService, UserService, PsFormComponent, PsHttp, PSCoreNg } from '@inflight/ps-core-ng';
import { StartHttpEvent, Http, LastResponseService, CoreNg } from '@inflight/core-ng';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { FieldComponent, UINgModule, HooksService } from '@inflight/ui-ng';
import { __awaiter } from 'tslib';
import { Router, ActivatedRoute } from '@angular/router';
import { IFResponse } from '@inflight/core-nlx';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@inflight/ui-ng';
import * as ɵngcc4 from '@ngx-translate/core';
import * as ɵngcc5 from '@inflight/core-ng';
import * as ɵngcc6 from '@inflight/ps-core-ng';
import * as ɵngcc7 from '@angular/router';

function LoginComponent_form_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "ui-input", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", field_r2)("form", ctx_r1.form);
} }
function LoginComponent_form_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "ui-input", 4);
    ɵngcc0.ɵɵlistener("change", function LoginComponent_form_0_Template_ui_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.changeOccurred(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "ui-input", 4);
    ɵngcc0.ɵɵlistener("change", function LoginComponent_form_0_Template_ui_input_change_5_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.changeOccurred(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, LoginComponent_form_0_div_6_Template, 2, 2, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "ui-error-box", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "div", 3);
    ɵngcc0.ɵɵelementStart(10, "button", 8);
    ɵngcc0.ɵɵlistener("click", function LoginComponent_form_0_Template_button_click_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); ctx_r6.login(); return $event.preventDefault(); });
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", ctx_r0.page.content.userID)("form", ctx_r0.form);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ctx_r0.page.content.password)("form", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.page.content.additionalFields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("error", ctx_r0.page.error);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("field", ctx_r0.signIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 9, ctx_r0.signIn.text));
} }
function AddressEditComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "ps-ui-input-lookup", 6);
    ɵngcc0.ɵɵlistener("lookup", function AddressEditComponent_div_1_Template_ps_ui_input_lookup_lookup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.triggerLookup($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.address.country)("form", ctx_r0.form);
} }
function AddressEditComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "ui-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r1.address.address2)("form", ctx_r1.form);
} }
function AddressEditComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "ui-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r2.address.address3)("form", ctx_r2.form);
} }
function AddressEditComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "ui-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r3.address.city)("form", ctx_r3.form);
} }
function AddressEditComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "ps-ui-input-lookup", 6);
    ɵngcc0.ɵɵlistener("lookup", function AddressEditComponent_div_7_Template_ps_ui_input_lookup_lookup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.triggerLookup($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r4.address.state)("form", ctx_r4.form);
} }
function AddressEditComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "ui-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r5.address.county)("form", ctx_r5.form);
} }
function AddressEditComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "ui-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r6.address.postal)("form", ctx_r6.form);
} }
function InputLookupComponent_ui_form_field_0_ng_template_1_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4.lookupLabel), "\u00A0");
} }
const _c0 = function (a0, a1) { return { "form-control-danger": a0, "is-invalid": a1 }; };
function InputLookupComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("input", function InputLookupComponent_ui_form_field_0_ng_template_1_Template_input_input_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.changeOccurred($event, field_r3); })("blur", function InputLookupComponent_ui_form_field_0_ng_template_1_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.checkForError(); })("keydown", function InputLookupComponent_ui_form_field_0_ng_template_1_Template_input_keydown_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.lookupClicked($event, field_r3.lookup); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 5);
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function InputLookupComponent_ui_form_field_0_ng_template_1_Template_button_click_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.lookupClicked($event, field_r3.lookup); });
    ɵngcc0.ɵɵelement(4, "i", 7);
    ɵngcc0.ɵɵtemplate(5, InputLookupComponent_ui_form_field_0_ng_template_1_span_5_Template, 3, 3, "span", 8);
    ɵngcc0.ɵɵelementStart(6, "span", 9);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", field_r3)("formControlName", field_r3.name)("required", field_r3.required)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c0, ctx_r2.hasError, ctx_r2.hasError));
    ɵngcc0.ɵɵattribute("data-if-id", (field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId) ? field_r3.extraAttributes.ifId + "-inputLookup" : "inputLookup");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", field_r3.id + "_lookup");
    ɵngcc0.ɵɵattribute("data-if-id", (field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId) ? field_r3.extraAttributes.ifId + "-lookupButton" : "lookupButton");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.lookupLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 9, "ps-ui.input-lookup.lookup-label"));
} }
function InputLookupComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputLookupComponent_ui_form_field_0_ng_template_1_Template, 9, 14, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("updateOn", ctx_r0.updateOn)("hasError", ctx_r0.hasError);
} }
function LookupComponent_div_0_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.lookup == null ? null : ctx_r1.lookup.header == null ? null : ctx_r1.lookup.header.instructions);
} }
function LookupComponent_div_0_div_5_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("for", content_r9.criteria.searchBy.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(content_r9.label);
} }
function LookupComponent_div_0_div_5_div_2_div_1_ui_select_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-select", 18);
    ɵngcc0.ɵɵlistener("change", function LookupComponent_div_0_div_5_div_2_div_1_ui_select_1_Template_ui_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const content_r9 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.doAction(content_r9.criteria.searchBy, true); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", content_r9.criteria.searchBy)("form", ctx_r17.form);
} }
function LookupComponent_div_0_div_5_div_2_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(content_r9.criteria.searchBy);
} }
function LookupComponent_div_0_div_5_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_2_div_1_ui_select_1_Template, 1, 2, "ui-select", 16);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_2_div_1_div_2_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria.searchBy.nodeType === "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !content_r9.criteria.searchBy.nodeType);
} }
function LookupComponent_div_0_div_5_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "label", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", content_r9.criteria.query.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(content_r9.criteria.searchType);
} }
function LookupComponent_div_0_div_5_div_2_div_3_ui_input_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input", 24);
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", content_r9.criteria.query)("form", ctx_r26.form);
} }
function LookupComponent_div_0_div_5_div_2_div_3_ui_select_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-select", 24);
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", content_r9.criteria.query)("form", ctx_r27.form);
} }
function LookupComponent_div_0_div_5_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_2_div_3_ui_input_1_Template, 1, 2, "ui-input", 23);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_2_div_3_ui_select_2_Template, 1, 2, "ui-select", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria.query.nodeType === "input");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria.query.nodeType === "select");
} }
function LookupComponent_div_0_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_2_div_1_Template, 3, 2, "div", 12);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_2_div_2_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_5_div_2_div_3_Template, 3, 2, "div", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria == null ? null : content_r9.criteria.searchBy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria.query && content_r9.criteria.searchType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.criteria.query);
} }
function LookupComponent_div_0_div_5_div_3_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "div", 28);
    ɵngcc0.ɵɵelement(2, "label", 29);
    ɵngcc0.ɵɵelement(3, "span", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r35 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerText", row_r35.searchBy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerText", row_r35.query);
} }
function LookupComponent_div_0_div_5_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_3_div_1_div_1_Template, 4, 2, "div", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", content_r9.readOnlyCriteria);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵelementStart(1, "ui-select", 18);
    ɵngcc0.ɵɵlistener("change", function LookupComponent_div_0_div_5_div_3_div_2_div_1_Template_ui_select_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r48); const row_r37 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r46 = ɵngcc0.ɵɵnextContext(4); return ctx_r46.doAction(row_r37.searchType, true); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r39 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", row_r37.searchType)("form", ctx_r39.form);
} }
const _c1 = function (a0) { return { criteria: a0 }; };
function LookupComponent_div_0_div_5_div_3_div_2_label_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "ps-ui.lookup.search_field_label", ɵngcc0.ɵɵpureFunction1(4, _c1, row_r37.searchType.label)));
} }
function LookupComponent_div_0_div_5_div_3_div_2_label_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(1, 1, "ps-ui.lookup.first_search_field_label", ɵngcc0.ɵɵpureFunction1(4, _c1, row_r37.searchType.label)));
} }
function LookupComponent_div_0_div_5_div_3_div_2_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 21);
    ɵngcc0.ɵɵelementStart(1, "span", 37);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_3_div_2_label_3_ng_container_2_Template, 3, 6, "ng-container", 38);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_5_div_3_div_2_label_3_ng_template_3_Template, 2, 6, "ng-template", null, 39, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r51 = ɵngcc0.ɵɵreference(4);
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("for", row_r37.query == null ? null : row_r37.query.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !row_r37.secondaryQuery)("ngIfElse", _r51);
} }
function LookupComponent_div_0_div_5_div_3_div_2_ui_input_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r41 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.query)("form", ctx_r41.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_ps_ui_input_lookup_5_Template(rf, ctx) { if (rf & 1) {
    const _r58 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ps-ui-input-lookup", 40);
    ɵngcc0.ɵɵlistener("lookup", function LookupComponent_div_0_div_5_div_3_div_2_ps_ui_input_lookup_5_Template_ps_ui_input_lookup_lookup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r58); const ctx_r57 = ɵngcc0.ɵɵnextContext(5); return ctx_r57.doNestedLookup($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r42 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.query)("form", ctx_r42.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_ui_input_date_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input-date", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r43 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.query)("form", ctx_r43.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_ui_select_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-select", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r44 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.query)("form", ctx_r44.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", row_r37.relationLabel, ":");
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 45);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("for", row_r37.secondaryQuery.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 2, "ps-ui.lookup.second_search_field_label", ɵngcc0.ɵɵpureFunction1(5, _c1, row_r37.searchType.label)));
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_input_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r64 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.secondaryQuery)("form", ctx_r64.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_ps_ui_input_lookup_4_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ps-ui-input-lookup", 40);
    ɵngcc0.ɵɵlistener("lookup", function LookupComponent_div_0_div_5_div_3_div_2_div_8_ps_ui_input_lookup_4_Template_ps_ui_input_lookup_lookup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r71 = ɵngcc0.ɵɵnextContext(6); return ctx_r71.doNestedLookup($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r65 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.secondaryQuery)("form", ctx_r65.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_input_date_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input-date", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r66 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.secondaryQuery)("form", ctx_r66.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_select_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-select", 24);
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r67 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("field", row_r37.secondaryQuery)("form", ctx_r67.form);
} }
function LookupComponent_div_0_div_5_div_3_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 41);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_3_div_2_div_8_div_1_Template, 2, 1, "div", 42);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_3_div_2_div_8_label_2_Template, 3, 7, "label", 43);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_input_3_Template, 1, 2, "ui-input", 23);
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_div_5_div_3_div_2_div_8_ps_ui_input_lookup_4_Template, 1, 2, "ps-ui-input-lookup", 34);
    ɵngcc0.ɵɵtemplate(5, LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_input_date_5_Template, 1, 2, "ui-input-date", 23);
    ɵngcc0.ɵɵtemplate(6, LookupComponent_div_0_div_5_div_3_div_2_div_8_ui_select_6_Template, 1, 2, "ui-select", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.relationLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.relationLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.nodeType) === "input" && !(row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.lookup) && !(row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.dateFormat));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.lookup) && !(row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.dateFormat));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.dateFormat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.secondaryQuery == null ? null : row_r37.secondaryQuery.nodeType) === "select");
} }
function LookupComponent_div_0_div_5_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_3_div_2_div_1_Template, 2, 2, "div", 31);
    ɵngcc0.ɵɵelementStart(2, "div", 32);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_5_div_3_div_2_label_3_Template, 6, 3, "label", 33);
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_div_5_div_3_div_2_ui_input_4_Template, 1, 2, "ui-input", 23);
    ɵngcc0.ɵɵtemplate(5, LookupComponent_div_0_div_5_div_3_div_2_ps_ui_input_lookup_5_Template, 1, 2, "ps-ui-input-lookup", 34);
    ɵngcc0.ɵɵtemplate(6, LookupComponent_div_0_div_5_div_3_div_2_ui_input_date_6_Template, 1, 2, "ui-input-date", 23);
    ɵngcc0.ɵɵtemplate(7, LookupComponent_div_0_div_5_div_3_div_2_ui_select_7_Template, 1, 2, "ui-select", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, LookupComponent_div_0_div_5_div_3_div_2_div_8_Template, 7, 6, "div", 35);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r37 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.searchType);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.searchType == null ? null : row_r37.searchType.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.query == null ? null : row_r37.query.nodeType) === "input" && !(row_r37.query == null ? null : row_r37.query.lookup) && !(row_r37.query == null ? null : row_r37.query.dateFormat));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.query == null ? null : row_r37.query.nodeType) === "input" && (row_r37.query == null ? null : row_r37.query.lookup) && !(row_r37.query == null ? null : row_r37.query.dateFormat));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.query == null ? null : row_r37.query.nodeType) === "input" && (row_r37.query == null ? null : row_r37.query.dateFormat));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (row_r37.query == null ? null : row_r37.query.nodeType) === "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r37.secondaryQuery);
} }
function LookupComponent_div_0_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_div_3_div_1_Template, 2, 1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_3_div_2_Template, 9, 7, "div", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.readOnlyCriteria == null ? null : content_r9.readOnlyCriteria.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", content_r9.criteria);
} }
function LookupComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_5_label_1_Template, 2, 2, "label", 8);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_5_div_2_Template, 4, 3, "div", 9);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_5_div_3_Template, 3, 2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (content_r9.criteria == null ? null : content_r9.criteria.searchBy == null ? null : content_r9.criteria.searchBy.nodeType) === "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !content_r9.isAdvanced);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", content_r9.isAdvanced);
} }
function LookupComponent_div_0_div_6_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r81 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 48);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_6_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r81); const ctx_r80 = ɵngcc0.ɵɵnextContext(3); return ctx_r80.actionTriggered(ctx_r80.lookup.content.criteriaBlock.actions.toggleLookup, true); });
    ɵngcc0.ɵɵelementStart(1, "span", 49);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "i", 50);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const criteriaBlock_r78 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r79 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", ctx_r79.lookup.content.criteriaBlock.actions.toggleLookup.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r79.lookup.content.criteriaBlock.actions.toggleLookup.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("ifc-chevron-up", criteriaBlock_r78.content == null ? null : criteriaBlock_r78.content.isAdvanced)("ifc-chevron-down", !(criteriaBlock_r78.content == null ? null : criteriaBlock_r78.content.isAdvanced));
} }
function LookupComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 46);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_6_a_1_Template, 4, 6, "a", 47);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const criteriaBlock_r78 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", criteriaBlock_r78 == null ? null : criteriaBlock_r78.actions == null ? null : criteriaBlock_r78.actions.toggleLookup);
} }
function LookupComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 51);
    ɵngcc0.ɵɵelementStart(1, "div", 52);
    ɵngcc0.ɵɵelementStart(2, "div", 53);
    ɵngcc0.ɵɵelementStart(3, "div", 54);
    ɵngcc0.ɵɵelement(4, "i", 55);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.lookup.error);
} }
function LookupComponent_div_0_ui_loading_spinner_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-loading-spinner");
} }
function LookupComponent_div_0_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r89 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 62);
    ɵngcc0.ɵɵelementStart(1, "button", 63);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_9_div_3_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r89); const lookup_r87 = restoredCtx.$implicit; const ctx_r88 = ɵngcc0.ɵɵnextContext(3); return ctx_r88.actionTriggered(lookup_r87, true); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lookup_r87 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", lookup_r87);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(lookup_r87.label);
} }
function LookupComponent_div_0_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r92 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 64);
    ɵngcc0.ɵɵelementStart(1, "button", 63);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_9_div_4_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r92); const clear_r90 = restoredCtx.$implicit; const ctx_r91 = ɵngcc0.ɵɵnextContext(3); return ctx_r91.actionTriggered(clear_r90, true); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const clear_r90 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", clear_r90);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(clear_r90.label);
} }
function LookupComponent_div_0_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r95 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 65);
    ɵngcc0.ɵɵelementStart(1, "button", 63);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_9_div_5_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r95); const cancel_r93 = restoredCtx.$implicit; const ctx_r94 = ɵngcc0.ɵɵnextContext(3); return ctx_r94.cancelLookup(cancel_r93); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const cancel_r93 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", cancel_r93);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(cancel_r93.label);
} }
function LookupComponent_div_0_div_9_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r98 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 66);
    ɵngcc0.ɵɵelementStart(1, "div", 67);
    ɵngcc0.ɵɵelementStart(2, "button", 68);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_9_div_6_Template_button_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r98); const ok_r96 = restoredCtx.$implicit; const ctx_r97 = ɵngcc0.ɵɵnextContext(3); return ctx_r97.submit(ok_r96); });
    ɵngcc0.ɵɵtext(3, " Done");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ok_r96 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ok_r96);
} }
function LookupComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 56);
    ɵngcc0.ɵɵelementStart(2, "div", 57);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_9_div_3_Template, 3, 2, "div", 58);
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_div_9_div_4_Template, 3, 2, "div", 59);
    ɵngcc0.ɵɵtemplate(5, LookupComponent_div_0_div_9_div_5_Template, 3, 2, "div", 60);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, LookupComponent_div_0_div_9_div_6_Template, 4, 1, "div", 61);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.lookup.content == null ? null : ctx_r6.lookup.content.criteriaBlock == null ? null : ctx_r6.lookup.content.criteriaBlock.actions == null ? null : ctx_r6.lookup.content.criteriaBlock.actions.lookup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.lookup.content == null ? null : ctx_r6.lookup.content.criteriaBlock == null ? null : ctx_r6.lookup.content.criteriaBlock.actions == null ? null : ctx_r6.lookup.content.criteriaBlock.actions.clear);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.lookup.actions == null ? null : ctx_r6.lookup.actions.cancel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.lookup.actions == null ? null : ctx_r6.lookup.actions.ok);
} }
function LookupComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ps-ui.lookup.no_matching_values"), " ");
} }
function LookupComponent_div_0_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 46);
    ɵngcc0.ɵɵelementStart(1, "label", 75);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "span", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 2, "ps-ui.lookup.selected"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerText", ctx_r99.selected.join(", "));
} }
function LookupComponent_div_0_div_11_li_6_a_1_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 83);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const header_r109 = ctx.$implicit;
    const i_r104 = ɵngcc0.ɵɵnextContext(2).index;
    ɵngcc0.ɵɵproperty("id", "label" + i_r104);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", header_r109.text || header_r109, " ");
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const header_r116 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", header_r116.text, ":");
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const header_r116 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵtextInterpolate1("", header_r116, ":");
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 86);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_ng_container_1_Template, 2, 1, "ng-container", 38);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_ng_template_2_Template, 1, 1, "ng-template", null, 87, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const header_r116 = ctx.$implicit;
    const _r118 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", header_r116.nodeType === "a")("ngIfElse", _r118);
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r124 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 88);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_11_li_6_a_1_div_4_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r124); const data_r111 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r123 = ɵngcc0.ɵɵnextContext(2); const i_r104 = ctx_r123.index; const row_r103 = ctx_r123.$implicit; const ctx_r122 = ɵngcc0.ɵɵnextContext(3); return ctx_r122.select(i_r104, row_r103, data_r111.action, $event); });
    ɵngcc0.ɵɵelement(1, "span", 89);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r111 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("title", data_r111.text || data_r111.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", data_r111.text || data_r111.value, ɵngcc0.ɵɵsanitizeHtml);
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r111 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(data_r111);
} }
function LookupComponent_div_0_div_11_li_6_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_1_div_4_label_1_Template, 4, 2, "label", 84);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_11_li_6_a_1_div_4_a_2_Template, 2, 2, "a", 85);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_11_li_6_a_1_div_4_span_3_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r111 = ctx.$implicit;
    const j_r112 = ctx.index;
    const ctx_r108 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r108.lookup.content == null ? null : ctx_r108.lookup.content.results == null ? null : ctx_r108.lookup.content.results.headings == null ? null : ctx_r108.lookup.content.results.headings.data[j_r112 + 1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", data_r111.nodeType === "a");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !data_r111.nodeType);
} }
function LookupComponent_div_0_div_11_li_6_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r130 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 79);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_11_li_6_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r130); const ctx_r129 = ɵngcc0.ɵɵnextContext(); const i_r104 = ctx_r129.index; const row_r103 = ctx_r129.$implicit; const ctx_r128 = ɵngcc0.ɵɵnextContext(3); return ctx_r128.select(i_r104, row_r103, row_r103.data[0].action, $event); });
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_1_label_1_Template, 2, 2, "label", 80);
    ɵngcc0.ɵɵelementStart(2, "div", 81);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_div_11_li_6_a_1_div_4_Template, 4, 3, "div", 82);
    ɵngcc0.ɵɵpipe(5, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r131 = ɵngcc0.ɵɵnextContext();
    const row_r103 = ctx_r131.$implicit;
    const i_r104 = ctx_r131.index;
    const ctx_r105 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("title", row_r103.data[0].text || row_r103.data[0].value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r105.lookup.content == null ? null : ctx_r105.lookup.content.results == null ? null : ctx_r105.lookup.content.results.headings == null ? null : ctx_r105.lookup.content.results.headings.data[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-labelledby", "label" + i_r104);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", row_r103.data[0].text || row_r103.data[0].value, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(5, 5, row_r103.data, 1));
} }
function LookupComponent_div_0_div_11_li_6_a_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 37);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ps-ui.lookup.selected"));
} }
function LookupComponent_div_0_div_11_li_6_a_2_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 83);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const header_r135 = ctx.$implicit;
    const i_r104 = ɵngcc0.ɵɵnextContext(2).index;
    ɵngcc0.ɵɵproperty("id", "label" + i_r104);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", header_r135.text || header_r135, " ");
} }
function LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const header_r140 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", header_r140.text, ":");
} }
function LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const header_r140 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵtextInterpolate1("", header_r140, ":");
} }
function LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 86);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_ng_container_1_Template, 2, 1, "ng-container", 38);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_ng_template_2_Template, 1, 1, "ng-template", null, 87, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const header_r140 = ctx.$implicit;
    const _r142 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", header_r140.nodeType === "a")("ngIfElse", _r142);
} }
function LookupComponent_div_0_div_11_li_6_a_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_2_div_8_label_1_Template, 4, 2, "label", 84);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r137 = ctx.$implicit;
    const i_r138 = ctx.index;
    const ctx_r134 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r134.lookup.content == null ? null : ctx_r134.lookup.content.results == null ? null : ctx_r134.lookup.content.results.headings == null ? null : ctx_r134.lookup.content.results.headings.data[i_r138 + 2]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(data_r137.text || data_r137.value || data_r137);
} }
function LookupComponent_div_0_div_11_li_6_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r148 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 90);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_11_li_6_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r148); const row_r103 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r146 = ɵngcc0.ɵɵnextContext(3); return ctx_r146.include(row_r103.data[0], row_r103.data[1]); });
    ɵngcc0.ɵɵelementStart(1, "div", 91);
    ɵngcc0.ɵɵelement(2, "i", 92);
    ɵngcc0.ɵɵtemplate(3, LookupComponent_div_0_div_11_li_6_a_2_span_3_Template, 3, 3, "span", 93);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵtemplate(5, LookupComponent_div_0_div_11_li_6_a_2_label_5_Template, 2, 2, "label", 80);
    ɵngcc0.ɵɵelementStart(6, "div", 81);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, LookupComponent_div_0_div_11_li_6_a_2_div_8_Template, 4, 2, "div", 82);
    ɵngcc0.ɵɵpipe(9, "slice");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r149 = ɵngcc0.ɵɵnextContext();
    const row_r103 = ctx_r149.$implicit;
    const i_r104 = ctx_r149.index;
    const ctx_r106 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("title", (row_r103.data[0].checked ? "Remove " : "Select ") + (row_r103.data[1] == null ? null : row_r103.data[1].text) || (row_r103.data[1] == null ? null : row_r103.data[1].value));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("text-primary", row_r103.data[0].checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r103.data[0].checked);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r106.lookup.content == null ? null : ctx_r106.lookup.content.results == null ? null : ctx_r106.lookup.content.results.headings == null ? null : ctx_r106.lookup.content.results.headings.data[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-labelledby", "label" + i_r104);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", row_r103.data[1].text || row_r103.data[1].value, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(9, 8, row_r103.data, 2));
} }
function LookupComponent_div_0_div_11_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 76);
    ɵngcc0.ɵɵtemplate(1, LookupComponent_div_0_div_11_li_6_a_1_Template, 6, 8, "a", 77);
    ɵngcc0.ɵɵtemplate(2, LookupComponent_div_0_div_11_li_6_a_2_Template, 10, 11, "a", 78);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r103 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("bg-light", row_r103.data[0].checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r103.data[0].nodeType === "a");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", row_r103.data[0].nodeType === "input");
} }
function LookupComponent_div_0_div_11_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r152 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 94);
    ɵngcc0.ɵɵelementStart(1, "div", 95);
    ɵngcc0.ɵɵelementStart(2, "button", 68);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_11_div_7_Template_button_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r152); const ok_r150 = restoredCtx.$implicit; const ctx_r151 = ɵngcc0.ɵɵnextContext(3); return ctx_r151.submit(ok_r150); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ok_r150 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ok_r150);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "ps-ui.lookup.done"));
} }
function LookupComponent_div_0_div_11_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r155 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 67);
    ɵngcc0.ɵɵelementStart(1, "button", 68);
    ɵngcc0.ɵɵlistener("click", function LookupComponent_div_0_div_11_div_9_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r155); const loadmore_r153 = restoredCtx.$implicit; const ctx_r154 = ɵngcc0.ɵɵnextContext(3); return ctx_r154.loadMore(loadmore_r153); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const loadmore_r153 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", loadmore_r153);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(loadmore_r153.label);
} }
function LookupComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 69);
    ɵngcc0.ɵɵelementStart(1, "ui-dynamic-heading", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_div_11_div_4_Template, 5, 4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "ul", 70);
    ɵngcc0.ɵɵtemplate(6, LookupComponent_div_0_div_11_li_6_Template, 3, 4, "li", 71);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, LookupComponent_div_0_div_11_div_7_Template, 5, 4, "div", 72);
    ɵngcc0.ɵɵelementStart(8, "div", 73);
    ɵngcc0.ɵɵtemplate(9, LookupComponent_div_0_div_11_div_9_Template, 3, 2, "div", 74);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap("sr-only");
    ɵngcc0.ɵɵproperty("headingLevel", ctx_r8.referenceHeading ? 1 : 2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 8, "ps-ui.lookup.results_heading"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.selected == null ? null : ctx_r8.selected.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.lookup.content == null ? null : ctx_r8.lookup.content.results == null ? null : ctx_r8.lookup.content.results.rows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.lookup.actions == null ? null : ctx_r8.lookup.actions.ok);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.lookup.content == null ? null : ctx_r8.lookup.content.criteriaBlock == null ? null : ctx_r8.lookup.content.criteriaBlock.actions == null ? null : ctx_r8.lookup.content.criteriaBlock.actions.loadMore);
} }
function LookupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "header");
    ɵngcc0.ɵɵelementStart(2, "ui-dynamic-heading", 2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, LookupComponent_div_0_p_4_Template, 2, 1, "p", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, LookupComponent_div_0_div_5_Template, 4, 3, "div", 3);
    ɵngcc0.ɵɵtemplate(6, LookupComponent_div_0_div_6_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(7, LookupComponent_div_0_div_7_Template, 7, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(8, LookupComponent_div_0_ui_loading_spinner_8_Template, 1, 0, "ui-loading-spinner", 3);
    ɵngcc0.ɵɵtemplate(9, LookupComponent_div_0_div_9_Template, 7, 4, "div", 3);
    ɵngcc0.ɵɵtemplate(10, LookupComponent_div_0_div_10_Template, 3, 3, "div", 3);
    ɵngcc0.ɵɵtemplate(11, LookupComponent_div_0_div_11_Template, 10, 10, "div", 6);
    ɵngcc0.ɵɵelement(12, "ui-hiddens", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("uiDynamicHeadings", ctx_r0.referenceHeading);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleMap("h2");
    ɵngcc0.ɵɵclassProp("d-none", ctx_r0.inline);
    ɵngcc0.ɵɵproperty("headingLevel", 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.lookup == null ? null : ctx_r0.lookup.header == null ? null : ctx_r0.lookup.header.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup == null ? null : ctx_r0.lookup.header == null ? null : ctx_r0.lookup.header.instructions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup == null ? null : ctx_r0.lookup.content.criteriaBlock.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup == null ? null : ctx_r0.lookup.content == null ? null : ctx_r0.lookup.content.criteriaBlock);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup == null ? null : ctx_r0.lookup.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup && !(ctx_r0.lookup == null ? null : ctx_r0.lookup.content.results) && !ctx_r0.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookup == null ? null : ctx_r0.lookup.content == null ? null : ctx_r0.lookup.content.results == null ? null : ctx_r0.lookup.content.results.rows == null ? null : ctx_r0.lookup.content.results.rows.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fields", ctx_r0.lookup == null ? null : ctx_r0.lookup.hiddens)("form", ctx_r0.form);
} }
class LoginComponent {
    constructor() {
        this.forceSyncModel = false;
        this.loginClicked = new EventEmitter();
    }
    login() {
        if (this.forceSyncModel) {
            this.doSyncModel();
        }
        this.loginClicked.emit();
    }
    ngOnInit() {
        this.signIn = this.page.actions.signin;
    }
    changeOccurred() {
        this.signIn.disabled = !this.form.valid;
    }
    doSyncModel() {
        // Added for Xamarin: when using iOS password fill the angular
        // model doesn't update properly.
        const syncNames = [this.page.content.userID.name, this.page.content.password.name];
        const patch = {};
        for (let i = 0; i < syncNames.length; i++) {
            const name = syncNames[i];
            const el = document.getElementsByName(name);
            let val;
            if (el && el.length === 1) {
                val = el[0].value;
            }
            if (val) {
                patch[name] = val;
            }
        }
        this.form.patchValue(patch);
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(); };
LoginComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["ps-ui-login"]], inputs: { forceSyncModel: "forceSyncModel", page: "page", form: "form" }, outputs: { loginClicked: "loginClicked" }, decls: 1, vars: 1, consts: [["method", "POST", 3, "formGroup", 4, "ngIf"], ["method", "POST", 3, "formGroup"], [1, "row"], [1, "col-12"], [3, "field", "form", "change"], ["class", "col-12", 4, "ngFor", "ngForOf"], [3, "error"], [1, "row", "mt-4"], ["base-button", "", 1, "btn", "btn-primary", "mb-3", "btn-block", "btn-lg", 3, "field", "click"], [3, "field", "form"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LoginComponent_form_0_Template, 13, 11, "form", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.page);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.ɵNgNoValidate, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.InputComponent, ɵngcc1.NgForOf, ɵngcc3.ErrorBoxComponent, ɵngcc3.ButtonDirective], pipes: [ɵngcc4.TranslatePipe], encapsulation: 2 });
LoginComponent.propDecorators = {
    page: [{ type: Input }],
    form: [{ type: Input }],
    forceSyncModel: [{ type: Input }],
    loginClicked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'ps-ui-login',
                template: "<form [formGroup]=\"form\" method=\"POST\" *ngIf=\"page\">\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <ui-input [field]=\"page.content.userID\" [form]=\"form\" (change)=\"changeOccurred()\"></ui-input>\n        </div>\n        <div class=\"col-12\">\n            <ui-input [field]=\"page.content.password\" [form]=\"form\" (change)=\"changeOccurred()\"></ui-input>\n        </div>\n        <div class=\"col-12\" *ngFor=\"let field of page.content.additionalFields\">\n            <ui-input [field]=\"field\" [form]=\"form\"></ui-input>\n        </div>\n    </div>\n    <ui-error-box [error]=\"page.error\"></ui-error-box>\n    <div class=\"row mt-4\">\n        <div class=\"col-12\">\n            <button base-button class=\"btn btn-primary mb-3 btn-block btn-lg\" (click)=\"login();$event.preventDefault();\" [field]=\"signIn\">{{signIn.text | translate}}</button>\n        </div>\n    </div>\n</form>\n"
            }]
    }], function () { return []; }, { forceSyncModel: [{
            type: Input
        }], loginClicked: [{
            type: Output
        }], page: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class SessionTimerService {
    constructor(http, settings, userService) {
        this.http = http;
        this.settings = settings;
        this.userService = userService;
        this.timeoutWarning = new EventEmitter(false);
        this.timeoutWarningObservable = this.timeoutWarning.asObservable();
        this.userService.loginStatus.pipe(distinctUntilChanged()).subscribe(isLoggedIn => {
            this.isLoggedIn = isLoggedIn;
            if (isLoggedIn) {
                this.startTimer();
            }
            else {
                this.clearTimer();
            }
        });
        this.http.httpEvents.subscribe(evt => {
            if (evt instanceof StartHttpEvent && evt.notify && this.isLoggedIn) {
                this.resetTimer();
            }
        });
    }
    startTimer() {
        const sessionTimerConfigs = this.settings.getExt('sessionTimer');
        if (!sessionTimerConfigs) {
            console.warn('No session timer configuration found, session timer will be disabled');
            return;
        }
        this.warningTimer = setTimeout(() => {
            this.timeoutWarning.emit(true);
            this.logoutTimer = setTimeout(() => {
                this.userService.logout();
            }, sessionTimerConfigs.timeoutAfter - sessionTimerConfigs.warnAfter);
        }, sessionTimerConfigs.warnAfter);
    }
    clearTimer() {
        this.timeoutWarning.emit(false);
        clearTimeout(this.logoutTimer);
        clearTimeout(this.warningTimer);
    }
    resetTimer() {
        this.clearTimer();
        this.startTimer();
    }
    get timeoutStatus() {
        return this.timeoutWarningObservable;
    }
}
SessionTimerService.ɵfac = function SessionTimerService_Factory(t) { return new (t || SessionTimerService)(ɵngcc0.ɵɵinject(ɵngcc5.Http), ɵngcc0.ɵɵinject(ɵngcc6.SettingsService), ɵngcc0.ɵɵinject(ɵngcc6.UserService)); };
SessionTimerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SessionTimerService, factory: SessionTimerService.ɵfac });
SessionTimerService.ctorParameters = () => [
    { type: Http },
    { type: SettingsService },
    { type: UserService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionTimerService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.Http }, { type: ɵngcc6.SettingsService }, { type: ɵngcc6.UserService }]; }, null); })();

class SessionTimerComponent {
    constructor(sessionTimerService, translate) {
        this.sessionTimerService = sessionTimerService;
        this.translate = translate;
        this.translate.get('ps-ui.session-timer.title').subscribe(message => {
            this.warningMessage = message;
        });
        this.refreshSession = new EventEmitter();
        this.done = new EventEmitter();
        this.sessionTimerService.timeoutStatus.pipe(distinctUntilChanged()).subscribe((timeoutWarning) => {
            if (timeoutWarning) {
                this.blinkTitle(true);
            }
            else {
                this.blinkTitle(false);
            }
        });
    }
    ngOnDestroy() {
        this.refreshSession.complete();
        this.done.complete();
    }
    blinkTitle(on) {
        if (on) {
            this.originalTitle = document.title || '';
            this.titleInterval = setInterval(() => {
                if (document.title === this.originalTitle) {
                    document.title = this.warningMessage;
                }
                else {
                    document.title = this.originalTitle;
                }
            }, 1000);
        }
        else {
            if (this.titleInterval) {
                clearInterval(this.titleInterval);
            }
            if (this.originalTitle) {
                document.title = this.originalTitle;
            }
            this.originalTitle = undefined;
        }
    }
    continueSession() {
        this.sessionTimerService.resetTimer();
        this.done.emit();
        this.refreshSession.emit();
    }
}
SessionTimerComponent.ɵfac = function SessionTimerComponent_Factory(t) { return new (t || SessionTimerComponent)(ɵngcc0.ɵɵdirectiveInject(SessionTimerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
SessionTimerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SessionTimerComponent, selectors: [["ps-ui-session-timer"]], outputs: { refreshSession: "refreshSession", done: "done" }, decls: 10, vars: 6, consts: [[1, "d-block", "card"], [1, "card-body", "px-4", "px-lg-5"], ["id", "timeoutWarningMsg", 1, "lead"], [1, "card-footer", "px-4"], ["aria-describedby", "timeoutWarningMsg", 1, "btn", "btn-primary", "btn-block", "mr-2", "pl-5", "pr-5", 3, "click"]], template: function SessionTimerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "p", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function SessionTimerComponent_Template_button_click_7_listener() { return ctx.continueSession(); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 2, "ps-ui.session-timer.message"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(9, 4, "ps-ui.session-timer.ok"), " ");
    } }, pipes: [ɵngcc4.TranslatePipe], encapsulation: 2 });
SessionTimerComponent.ctorParameters = () => [
    { type: SessionTimerService },
    { type: TranslateService }
];
SessionTimerComponent.propDecorators = {
    refreshSession: [{ type: Output }],
    done: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionTimerComponent, [{
        type: Component,
        args: [{
                selector: 'ps-ui-session-timer',
                template: "<ng-container>\n    <div class=\"d-block card\">\n        <div class=\"card-body px-4 px-lg-5\">\n            <p class=\"lead\" id=\"timeoutWarningMsg\">{{ 'ps-ui.session-timer.message' | translate }}</p>\n        </div>\n        <div class=\"card-footer px-4\">\n            <button aria-describedby=\"timeoutWarningMsg\" class=\"btn btn-primary btn-block mr-2 pl-5 pr-5\" (click)=\"continueSession()\">{{\n                'ps-ui.session-timer.ok' | translate }} </button>\n        </div>\n    </div>\n</ng-container>\n\n\n"
            }]
    }], function () { return [{ type: SessionTimerService }, { type: ɵngcc4.TranslateService }]; }, { refreshSession: [{
            type: Output
        }], done: [{
            type: Output
        }] }); })();

class AddressEditComponent {
    constructor() {
        this.lookupTriggered = new EventEmitter();
    }
    triggerLookup(action) {
        this.lookupTriggered.emit(action);
    }
}
AddressEditComponent.ɵfac = function AddressEditComponent_Factory(t) { return new (t || AddressEditComponent)(); };
AddressEditComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AddressEditComponent, selectors: [["ps-ui-address-edit"]], inputs: { form: "form", address: "address" }, outputs: { lookupTriggered: "lookupTriggered" }, decls: 10, vars: 9, consts: [[1, "row"], ["class", "col-12", 4, "ngIf"], [1, "col-12"], [3, "field", "form"], ["class", "col-12 col-md-6", 4, "ngIf"], ["class", "col-12 col-lg-4 col-sm-6", 4, "ngIf"], [3, "field", "form", "lookup"], [1, "col-12", "col-md-6"], [1, "col-12", "col-lg-4", "col-sm-6"]], template: function AddressEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AddressEditComponent_div_1_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "ui-input", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, AddressEditComponent_div_4_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(5, AddressEditComponent_div_5_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(6, AddressEditComponent_div_6_Template, 2, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(7, AddressEditComponent_div_7_Template, 2, 2, "div", 5);
        ɵngcc0.ɵɵtemplate(8, AddressEditComponent_div_8_Template, 2, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(9, AddressEditComponent_div_9_Template, 2, 2, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.country);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.address.address1)("form", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.address2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.address3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.city);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.state);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.county);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address.postal);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc3.InputComponent, InputLookupComponent]; }, encapsulation: 2 });
AddressEditComponent.ctorParameters = () => [];
AddressEditComponent.propDecorators = {
    form: [{ type: Input }],
    address: [{ type: Input }],
    lookupTriggered: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddressEditComponent, [{
        type: Component,
        args: [{
                selector: 'ps-ui-address-edit',
                template: "<div class=\"row\">\n  <div class=\"col-12\" *ngIf=\"address.country\">\n    <ps-ui-input-lookup [field]=\"address.country\" [form]=\"form\" (lookup)=\"triggerLookup($event)\"></ps-ui-input-lookup>\n  </div>\n\n  <div class=\"col-12\">\n    <ui-input [field]=\"address.address1\" [form]=\"form\"></ui-input>\n  </div>\n\n  <div class=\"col-12\" *ngIf=\"address.address2\">\n    <ui-input [field]=\"address.address2\" [form]=\"form\"></ui-input>\n  </div>\n\n  <div class=\"col-12\" *ngIf=\"address.address3\">\n    <ui-input [field]=\"address.address3\" [form]=\"form\"></ui-input>\n  </div>\n\n  <div class=\"col-12 col-md-6\" *ngIf=\"address.city\">\n    <ui-input [field]=\"address.city\" [form]=\"form\"></ui-input>\n  </div>\n\n  <div class=\"col-12 col-lg-4 col-sm-6\" *ngIf=\"address.state\">\n    <ps-ui-input-lookup [field]=\"address.state\" [form]=\"form\" (lookup)=\"triggerLookup($event)\"></ps-ui-input-lookup>\n  </div>\n\n  <div class=\"col-12 col-md-6\" *ngIf=\"address.county\">\n    <ui-input [field]=\"address.county\" [form]=\"form\"></ui-input>\n  </div>\n\n  <div class=\"col-12 col-md-6\" *ngIf=\"address.postal\">\n    <ui-input [field]=\"address.postal\" [form]=\"form\"></ui-input>\n  </div>\n</div>"
            }]
    }], function () { return []; }, { lookupTriggered: [{
            type: Output
        }], form: [{
            type: Input
        }], address: [{
            type: Input
        }] }); })();

class InputLookupComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.lookup = new EventEmitter();
    }
    ngOnDestroy() {
        this.change.complete();
        this.lookup.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    lookupClicked($event, field) {
        if ($event instanceof KeyboardEvent && $event.which !== 13) {
            return;
        }
        else if ($event instanceof Event && !($event.currentTarget instanceof HTMLButtonElement)) {
            return;
        }
        $event.preventDefault();
        $event.stopPropagation();
        this.lookup.emit(field);
    }
}
InputLookupComponent.ɵfac = /*@__PURE__*/ function () { let ɵInputLookupComponent_BaseFactory; return function InputLookupComponent_Factory(t) { return (ɵInputLookupComponent_BaseFactory || (ɵInputLookupComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(InputLookupComponent)))(t || InputLookupComponent); }; }();
InputLookupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputLookupComponent, selectors: [["ps-ui-input-lookup"]], inputs: { field: "field", form: "form", lookupLabel: "lookupLabel" }, outputs: { change: "change", lookup: "lookup" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError"], ["template", ""], [1, "input-group"], ["base-input", "", "ifPII", "", 1, "form-control", 3, "field", "formControlName", "required", "ngClass", "input", "blur", "keydown"], [1, "input-group-prepend"], ["type", "button", 1, "btn", "btn-primary", 3, "id", "click"], ["aria-hidden", "true", 1, "ifc-icon", "ifc-search"], ["class", "sr-only", 4, "ngIf"], [1, "sr-only"]], template: function InputLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputLookupComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field == null ? null : ctx.field.lookup);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.FormFieldComponent, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.DefaultValueAccessor, ɵngcc3.InputDirective, ɵngcc5.IfPersonallyIdentifiableInformationDirective, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.RequiredValidator, ɵngcc1.NgClass], pipes: [ɵngcc4.TranslatePipe], encapsulation: 2 });
InputLookupComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    lookupLabel: [{ type: Input }],
    change: [{ type: Output }],
    lookup: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputLookupComponent, [{
        type: Component,
        args: [{
                selector: 'ps-ui-input-lookup',
                template: "<ui-form-field *ngIf=\"field?.lookup\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [updateOn]=\"updateOn\"\n    [hasError]=\"hasError\">\n    <ng-template #template let-field=\"field\">\n        <div class=\"input-group\">\n            <input base-input ifPII class=\"form-control\" [field]=\"field\" [formControlName]=\"field.name\"\n                (input)=\"changeOccurred($event, field)\" (blur)=\"checkForError()\" [required]=\"field.required\"\n                [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n                (keydown)=\"lookupClicked($event, field.lookup)\" [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-inputLookup' : 'inputLookup'\">\n            <span class=\"input-group-prepend\">\n                <button class=\"btn btn-primary\" type=\"button\" [id]=\"field.id + '_lookup'\" (click)=\"lookupClicked($event, field.lookup)\" [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-lookupButton' : 'lookupButton'  \">\n                    <i class=\"ifc-icon ifc-search\" aria-hidden=\"true\"></i>\n                    <span class=\"sr-only\" *ngIf=\"lookupLabel\">{{lookupLabel | translate}}&nbsp;</span>\n                    <span class=\"sr-only\">{{'ps-ui.input-lookup.lookup-label' | translate}}</span>\n                </button>\n            </span>\n        </div>\n    </ng-template>\n</ui-form-field>\n\n"
            }]
    }], null, { change: [{
            type: Output
        }], lookup: [{
            type: Output
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }], lookupLabel: [{
            type: Input
        }] }); })();

class LookupComponent extends PsFormComponent {
    constructor(service, formBuilder, lastResponseService, router, activatedRoute, el) {
        super(service, lastResponseService, formBuilder, router, activatedRoute);
        this.el = el;
        this.focusElementKey = '___PS_LOOKUP_FOCUS_ID___';
        this.lastResultIndex = 0;
        this.nestLevel = 0;
        this.selected = [];
        this.loading = false;
        this.inline = false;
        this.cancelClick = new EventEmitter();
        this.valueClick = new EventEmitter();
        this.lookupFailed = new EventEmitter();
    }
    ngOnInit() {
        if (this.lookupInit == null) {
            return super.ngOnInit();
        }
        if (this.lookupInit.hiddens) {
            this.lookupInit.hiddens.forEach(hidden => {
                this.form.value[hidden.id] = hidden.value;
            });
        }
        this.actionTriggered(this.lookupInit.action);
    }
    getTargetUrl() {
        if (this.lookupInit == null) {
            return '';
        }
        return this.lookupInit.targetUrl;
    }
    bind(response) {
        if (!response.Results.data.lookupPage) {
            return;
        }
        this.lookup = undefined;
        setTimeout(() => {
            this.selected = [];
            const lookupPageContent = response.Results.data.lookupPage.content;
            const criteriaBlockContent = response.Results.data.lookupPage.content.criteriaBlock.content;
            let results;
            if (lookupPageContent.results) {
                results = {
                    headings: lookupPageContent.results.headings,
                    rows: lookupPageContent.results.rows,
                    nativeOrdering: lookupPageContent.results.headings
                };
            }
            let criteriaBlock;
            if (!criteriaBlockContent.isAdvanced) {
                criteriaBlock = {
                    label: criteriaBlockContent.label,
                    isAdvanced: false,
                    criteria: {
                        searchBy: criteriaBlockContent.criteria.searchBy,
                        searchType: criteriaBlockContent.criteria.searchType,
                        query: criteriaBlockContent.criteria.query
                    }
                };
            }
            else {
                const criteria = [];
                const roCriteria = [];
                criteriaBlockContent.criteria.forEach((crit) => {
                    crit.searchType.label = crit.searchBy;
                    criteria.push({
                        searchBy: crit.searchBy,
                        searchType: crit.searchType,
                        query: crit.query,
                        relationLabel: crit.relationLabel,
                        secondaryQuery: crit.secondaryQuery
                    });
                });
                criteriaBlockContent.readOnlyCriteria.forEach((crit) => {
                    if (crit && (crit.searchBy || crit.query)) {
                        roCriteria.push({
                            searchBy: crit.searchBy,
                            searchType: undefined,
                            query: crit.query
                        });
                    }
                });
                criteriaBlock = {
                    isAdvanced: true,
                    readOnlyCriteria: roCriteria,
                    criteria: criteria
                };
            }
            const lookup = {
                header: response.Results.data.header || response.Results.data.lookupPage.header,
                content: {
                    criteriaBlock: {
                        content: criteriaBlock,
                        actions: {
                            lookup: lookupPageContent.criteriaBlock.actions.lookup,
                            clear: lookupPageContent.criteriaBlock.actions.clear,
                            toggleLookup: lookupPageContent.criteriaBlock.actions.toggleLookup,
                            loadMore: lookupPageContent.criteriaBlock.actions.loadMore
                        }
                    },
                    results: results
                },
                actions: {
                    cancel: response.Results.data.lookupPage.actions.cancel,
                    ok: response.Results.data.lookupPage.actions.ok
                },
                hiddens: response.Results.data.lookupPage.hiddens,
                error: response.Results.data.lookupPage.error
            };
            const criteriaBlockActions = lookup.content.criteriaBlock.actions;
            // fix incorrect model setup for IActions
            if (criteriaBlockActions.lookup && !criteriaBlockActions.lookup.label) {
                criteriaBlockActions.lookup.label = criteriaBlockActions.lookup.value || criteriaBlockActions.lookup.text;
            }
            if (criteriaBlockActions.clear && !criteriaBlockActions.clear.label) {
                criteriaBlockActions.clear.label = criteriaBlockActions.clear.value || criteriaBlockActions.clear.text;
            }
            const toggleLookup = criteriaBlockActions.toggleLookup;
            if (toggleLookup && !toggleLookup.label) {
                toggleLookup.label = toggleLookup.value || toggleLookup.text;
            }
            if (criteriaBlockActions.loadMore && !criteriaBlockActions.loadMore.label) {
                criteriaBlockActions.loadMore.label = criteriaBlockActions.loadMore.value || criteriaBlockActions.loadMore.text;
            }
            if (lookup.actions.cancel && !lookup.actions.cancel.label) {
                lookup.actions.cancel.label = lookup.actions.cancel.value || lookup.actions.cancel.text;
            }
            this.lookup = lookup;
            this.loading = false;
        });
        try {
            const focusElementId = sessionStorage.getItem(this.focusElementKey);
            if (focusElementId) {
                sessionStorage.removeItem(this.focusElementKey);
                setTimeout(() => {
                    this.el.nativeElement.querySelector(`[id="${focusElementId}"]`).focus();
                });
            }
        }
        catch (_a) { }
    }
    doNestedLookup(action) {
        this.nestLevel++;
        super.action(action, false);
    }
    cancelLookup(btn) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.doAction(btn);
            if (this.nestLevel === 0 && response instanceof IFResponse) {
                this.cancelClick.emit(response);
            }
            if (this.nestLevel > 0) {
                this.nestLevel--;
            }
        });
    }
    actionTriggered(action, showLoader = false) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = showLoader;
            const response = yield this.doAction(action);
            if (response.Results.data.lookupPage) {
                this.bind(response);
            }
            else {
                this.lookupFailed.emit(response);
            }
        });
    }
    doAction(action, saveFocus = false) {
        const _super = Object.create(null, {
            action: { get: () => super.action }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (saveFocus) {
                try {
                    sessionStorage.setItem(this.focusElementKey, action.id);
                }
                catch (_a) { }
            }
            return _super.action.call(this, action, !this.lookupInit);
        });
    }
    loadMore(action) {
        return __awaiter(this, void 0, void 0, function* () {
            this.form.value['ICAJAX'] = '1';
            this.lastResultIndex = this.lookup.content.results.rows.length;
            const response = yield this.doAction(action);
            if (response instanceof IFResponse) {
                const newResults = response.Results.data.loadMoreResults.rows;
                this.lookup.content.results.rows = this.lookup.content.results.rows.concat(newResults.splice(this.lastResultIndex, newResults.length));
                this.lookup.content.criteriaBlock.actions.loadMore = response.Results.data.loadMoreResults.loadMore;
            }
        });
    }
    select(i, row, action, $event) {
        return __awaiter(this, void 0, void 0, function* () {
            $event.stopPropagation();
            if (action) {
                row.id = action;
            }
            else {
                row.id = '#ICRow' + i;
            }
            const response = yield this.doAction(row);
            if (this.nestLevel === 0 && response instanceof IFResponse) {
                this.valueClick.emit(response);
            }
            if (this.nestLevel > 0) {
                this.nestLevel--;
            }
        });
    }
    submit(action) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.doAction(action);
            if (this.nestLevel === 0 && response instanceof IFResponse) {
                this.valueClick.emit(response);
            }
            if (this.nestLevel > 0) {
                this.nestLevel--;
            }
        });
    }
    include(field, data) {
        field.checked = !field.checked;
        const text = data['text'] || data['value'] || data;
        const onValue = field.onValue || 'on';
        if (!field.checked) {
            field.value = undefined;
            this.selected.splice(this.selected.indexOf(text), 1);
        }
        else {
            field.value = onValue;
            this.selected.push(text);
        }
        this.form.value[field.id] = field.value;
    }
}
LookupComponent.ɵfac = function LookupComponent_Factory(t) { return new (t || LookupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.PsHttp), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LastResponseService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
LookupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LookupComponent, selectors: [["ps-ui-lookup"]], inputs: { inline: "inline", referenceHeading: "referenceHeading", lookupInit: "lookupInit" }, outputs: { cancelClick: "cancelClick", valueClick: "valueClick", lookupFailed: "lookupFailed" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["uiModalDialog", "", 3, "uiDynamicHeadings", 4, "ngIf"], ["uiModalDialog", "", 3, "uiDynamicHeadings"], [3, "headingLevel"], [4, "ngIf"], ["class", "mb-3", 4, "ngIf"], ["class", "row", "id", "error_box", 4, "ngIf"], ["class", "border-top pt-3 mb-2", 4, "ngIf"], [3, "fields", "form"], ["class", "font-weight-bold text-uppercase", 3, "for", 4, "ngIf"], ["class", "row d-flex flex-row form-group mb-0", 4, "ngIf"], [1, "font-weight-bold", "text-uppercase", 3, "for"], [1, "row", "d-flex", "flex-row", "form-group", "mb-0"], ["class", "col-12 col-md-auto", 4, "ngIf"], ["class", "col-12 col-md-auto mb-3 mb-md-0 pl-md-0", 4, "ngIf"], ["class", "col-12 col-md-auto pl-md-0", 4, "ngIf"], [1, "col-12", "col-md-auto"], [3, "field", "form", "change", 4, "ngIf"], ["class", "font-weight-bold", 4, "ngIf"], [3, "field", "form", "change"], [1, "font-weight-bold"], [1, "col-12", "col-md-auto", "mb-3", "mb-md-0", "pl-md-0"], [3, "for"], [1, "col-12", "col-md-auto", "pl-md-0"], [3, "field", "form", 4, "ngIf"], [3, "field", "form"], ["class", "row d-flex flex-row form-group mb-0", 4, "ngFor", "ngForOf"], ["class", "col-12", 4, "ngFor", "ngForOf"], [1, "col-12"], [1, "form-group"], [1, "form-control-label", "mr-2", 3, "innerText"], [3, "innerText"], ["class", "col-12 col-sm-4", 4, "ngIf"], [1, "col-12", "col-sm-4", "pl-sm-0"], [3, "for", 4, "ngIf"], [3, "field", "form", "lookup", 4, "ngIf"], ["class", "col-12 pl-sm-0 col-sm-4", 4, "ngIf"], [1, "col-12", "col-sm-4"], [1, "sr-only"], [4, "ngIf", "ngIfElse"], ["hasSecondaryQuery", ""], [3, "field", "form", "lookup"], [1, "col-12", "pl-sm-0", "col-sm-4"], ["class", "form-control-label mb-2", 4, "ngIf"], ["class", "sr-only", 3, "for", 4, "ngIf"], [1, "form-control-label", "mb-2"], [1, "sr-only", 3, "for"], [1, "mb-3"], ["class", "btn btn-link text-primary pl-0", "href", "javascript:void(0);", 3, "title", "click", 4, "ngIf"], ["href", "javascript:void(0);", 1, "btn", "btn-link", "text-primary", "pl-0", 3, "title", "click"], [1, "align-middle", "mr-2"], [1, "align-middle", "ifc-icon"], ["id", "error_box", 1, "row"], [1, "col-xs-12"], [1, "alert", "alert-danger", "fade", "in"], [1, "h5"], [1, "fa", "fa-lg", "fa-warning"], [1, "row", "mb-4"], [1, "col-12", "col-sm-10", "row", "ml-0"], ["class", "col-12 col-sm-auto px-0 pr-sm-2 pb-2", 4, "ngIf"], ["class", "col-12 col-sm-auto px-0 px-sm-2 pb-2", 4, "ngIf"], ["class", "col-12 col-sm-auto px-0 px-sm-2", 4, "ngIf"], ["class", "col-12 col-sm-2 row ml-0 px-sm-0 justify-content-end", 4, "ngIf"], [1, "col-12", "col-sm-auto", "px-0", "pr-sm-2", "pb-2"], ["base-button", "", 1, "btn", "btn-outline-primary", "btn-block", 3, "field", "click"], [1, "col-12", "col-sm-auto", "px-0", "px-sm-2", "pb-2"], [1, "col-12", "col-sm-auto", "px-0", "px-sm-2"], [1, "col-12", "col-sm-2", "row", "ml-0", "px-sm-0", "justify-content-end"], [1, "col-12", "col-sm-auto", "px-0"], ["base-button", "", 1, "btn", "btn-primary", "btn-block", 3, "field", "click"], [1, "border-top", "pt-3", "mb-2"], [1, "list-unstyled", "list-group"], ["class", "list-group-item list-group-item-action", 3, "bg-light", 4, "ngFor", "ngForOf"], ["class", "row mt-3 justify-content-end", 4, "ngIf"], [1, "row", "clearfix", "mt-3", "justify-content-end", "mx-0"], ["class", "col-12 col-sm-auto px-0", 4, "ngIf"], [1, "font-weight-bold", "text-uppercase", "mb-0", "mr-1"], [1, "list-group-item", "list-group-item-action"], ["class", "d-block px-0 py-2 py-md-3 px-md-3", "href", "javascript:void(0)", 3, "title", "click", 4, "ngIf"], ["class", "d-flex flex-row px-2 py-2 py-md-3 px-md-3", "role", "action", "href", "javascript:void(0)", 3, "title", "click", 4, "ngIf"], ["href", "javascript:void(0)", 1, "d-block", "px-0", "py-2", "py-md-3", "px-md-3", 3, "title", "click"], ["class", "small text-uppercase text-muted mb-1 mb-md-2", 3, "id", 4, "ngIf"], [1, "h5", "font-weight-bold", "text-primary", "mb-1", "mb-md-2"], [4, "ngFor", "ngForOf"], [1, "small", "text-uppercase", "text-muted", "mb-1", "mb-md-2", 3, "id"], ["class", "font-weight-bold mr-2 mb-0", 4, "ngIf"], ["href", "javascript:void(0)", 3, "title", "click", 4, "ngIf"], [1, "font-weight-bold", "mr-2", "mb-0"], ["textHeader", ""], ["href", "javascript:void(0)", 3, "title", "click"], [3, "innerHTML"], ["role", "action", "href", "javascript:void(0)", 1, "d-flex", "flex-row", "px-2", "py-2", "py-md-3", "px-md-3", 3, "title", "click"], [1, "d-flex", "flex-row", "align-items-center", "text-muted", "pr-4", "mr-1"], [1, "font-weight-bold", "ifc-icon", "ifc-check"], ["class", "sr-only", 4, "ngIf"], [1, "row", "mt-3", "justify-content-end"], [1, "col-12", "col-sm-auto"]], template: function LookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LookupComponent_div_0_Template, 13, 17, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.lookup);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.ModalDialogDirective, ɵngcc3.DynamicHeadingDirective, ɵngcc3.DynamicHeadingComponent, ɵngcc3.HiddensComponent, ɵngcc3.SelectComponent, ɵngcc3.InputComponent, ɵngcc1.NgForOf, InputLookupComponent, ɵngcc3.InputDateComponent, ɵngcc3.LoadingSpinnerComponent, ɵngcc3.ButtonDirective], pipes: [ɵngcc4.TranslatePipe, ɵngcc1.SlicePipe], encapsulation: 2 });
LookupComponent.ctorParameters = () => [
    { type: PsHttp },
    { type: FormBuilder },
    { type: LastResponseService },
    { type: Router },
    { type: ActivatedRoute },
    { type: ElementRef }
];
LookupComponent.propDecorators = {
    referenceHeading: [{ type: Input }],
    inline: [{ type: Input }],
    lookupInit: [{ type: Input }],
    cancelClick: [{ type: Output }],
    valueClick: [{ type: Output }],
    lookupFailed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LookupComponent, [{
        type: Component,
        args: [{
                selector: 'ps-ui-lookup',
                template: "\n<div uiModalDialog [uiDynamicHeadings]=\"referenceHeading\" *ngIf=\"lookup\">\n  <header>\n    <ui-dynamic-heading [headingLevel]=\"1\" [style]=\"'h2'\" [class.d-none]=\"inline\">{{lookup?.header?.title}}</ui-dynamic-heading>\n    <p *ngIf=\"lookup?.header?.instructions\">{{lookup?.header?.instructions}}</p>\n  </header>\n  <div *ngIf=\"lookup?.content.criteriaBlock.content; let content\">\n    <label *ngIf=\"content.criteria?.searchBy?.nodeType === 'select'\" [for]=\"content.criteria.searchBy.id\"\n      class=\"font-weight-bold text-uppercase\">{{content.label}}</label>\n    <div *ngIf=\"!content.isAdvanced\" class=\"row d-flex flex-row form-group mb-0\">\n      <div class=\"col-12 col-md-auto\" *ngIf=\"content.criteria?.searchBy\">\n        <ui-select *ngIf=\"content.criteria.searchBy.nodeType === 'select'\"\n          (change)=\"doAction(content.criteria.searchBy, true)\" [field]=\"content.criteria.searchBy\" [form]=\"form\">\n        </ui-select>\n        <div class=\"font-weight-bold\" *ngIf=\"!content.criteria.searchBy.nodeType\">{{content.criteria.searchBy}}</div>\n      </div>\n      <div class=\"col-12 col-md-auto mb-3 mb-md-0 pl-md-0\"\n        *ngIf=\"content.criteria.query && content.criteria.searchType\">\n        <label [for]=\"content.criteria.query.id\">{{content.criteria.searchType}}</label>\n      </div>\n      <div class=\"col-12 col-md-auto pl-md-0\" *ngIf=\"content.criteria.query\">\n        <ui-input *ngIf=\"content.criteria.query.nodeType === 'input'\" [field]=\"content.criteria.query\" [form]=\"form\">\n        </ui-input>\n        <ui-select *ngIf=\"content.criteria.query.nodeType === 'select'\" [field]=\"content.criteria.query\" [form]=\"form\">\n        </ui-select>\n      </div>\n    </div>\n    <div *ngIf=\"content.isAdvanced\">\n      <div *ngIf=\"content.readOnlyCriteria?.length\" class=\"row d-flex flex-row form-group mb-0\">\n        <div *ngFor=\"let row of content.readOnlyCriteria\" class=\"col-12\">\n          <div class=\"form-group\">\n            <label class=\"form-control-label mr-2\" [innerText]=\"row.searchBy\"></label>\n            <span [innerText]=\"row.query\"></span>\n          </div>\n        </div>\n      </div>\n      <div *ngFor=\"let row of content.criteria; let i=index\" class=\"row d-flex flex-row form-group mb-0\">\n        <div class=\"col-12 col-sm-4\" *ngIf=\"row.searchType\">\n          <ui-select [field]=\"row.searchType\" (change)=\"doAction(row.searchType, true)\" [form]=\"form\"></ui-select>\n        </div>\n        <div class=\"col-12 col-sm-4 pl-sm-0\">\n          <label *ngIf=\"row.searchType?.label\" [for]=\"row.query?.id\">\n            <span class=\"sr-only\">\n              <ng-container *ngIf=\"!row.secondaryQuery; else hasSecondaryQuery\">{{'ps-ui.lookup.search_field_label' |\n                translate:{criteria: row.searchType.label} }}</ng-container>\n              <ng-template #hasSecondaryQuery>{{'ps-ui.lookup.first_search_field_label' | translate:{criteria:\n                row.searchType.label} }}</ng-template>\n            </span>\n            &nbsp;\n          </label>\n          <ui-input *ngIf=\"row.query?.nodeType === 'input' && !row.query?.lookup && !row.query?.dateFormat\"\n            [field]=\"row.query\" [form]=\"form\"></ui-input>\n          <ps-ui-input-lookup *ngIf=\"row.query?.nodeType === 'input' && row.query?.lookup && !row.query?.dateFormat\"\n            [field]=\"row.query\" [form]=\"form\" (lookup)=\"doNestedLookup($event)\"></ps-ui-input-lookup>\n          <ui-input-date *ngIf=\"row.query?.nodeType === 'input' && row.query?.dateFormat\" [field]=\"row.query\"\n            [form]=\"form\"></ui-input-date>\n          <ui-select *ngIf=\"row.query?.nodeType === 'select'\" [field]=\"row.query\" [form]=\"form\"></ui-select>\n        </div>\n        <div class=\"col-12 pl-sm-0 col-sm-4\" *ngIf=\"row.secondaryQuery\">\n          <div *ngIf=\"row.relationLabel\" class=\"form-control-label mb-2\">{{row.relationLabel}}:</div>\n          <label *ngIf=\"row.relationLabel\" [for]=\"row.secondaryQuery.id\"\n            class=\"sr-only\">{{'ps-ui.lookup.second_search_field_label' | translate:{criteria: row.searchType.label}\n            }}</label>\n          <ui-input\n            *ngIf=\"row.secondaryQuery?.nodeType === 'input' && !row.secondaryQuery?.lookup && !row.secondaryQuery?.dateFormat\"\n            [field]=\"row.secondaryQuery\" [form]=\"form\"></ui-input>\n          <ps-ui-input-lookup *ngIf=\"row.secondaryQuery?.lookup && !row.secondaryQuery?.dateFormat\"\n            [field]=\"row.secondaryQuery\" [form]=\"form\" (lookup)=\"doNestedLookup($event)\"></ps-ui-input-lookup>\n          <ui-input-date *ngIf=\"row.secondaryQuery?.dateFormat\" [field]=\"row.secondaryQuery\" [form]=\"form\">\n          </ui-input-date>\n          <ui-select *ngIf=\"row.secondaryQuery?.nodeType === 'select'\" [field]=\"row.secondaryQuery\" [form]=\"form\">\n          </ui-select>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"mb-3\" *ngIf=\"lookup?.content?.criteriaBlock; let criteriaBlock\">\n    <a class=\"btn btn-link text-primary pl-0\" href=\"javascript:void(0);\" *ngIf=\"criteriaBlock?.actions?.toggleLookup\"\n      (click)=\"actionTriggered(lookup.content.criteriaBlock.actions.toggleLookup, true)\"\n      [title]=\"lookup.content.criteriaBlock.actions.toggleLookup.label\">\n      <span class=\"align-middle mr-2\">{{lookup.content.criteriaBlock.actions.toggleLookup.label}}</span>\n      <i class=\"align-middle ifc-icon\" [class.ifc-chevron-up]=\"criteriaBlock.content?.isAdvanced\"\n        [class.ifc-chevron-down]=\"!criteriaBlock.content?.isAdvanced\"></i>\n    </a>\n  </div>\n  <div class=\"row\" id=\"error_box\" *ngIf=\"lookup?.error\">\n    <div class=\"col-xs-12\">\n      <div class=\"alert alert-danger fade in\">\n        <div class=\"h5\">\n          <i class=\"fa fa-lg fa-warning\"></i>\n          <span>{{lookup.error}}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ui-loading-spinner *ngIf=\"loading\"></ui-loading-spinner>\n  <div *ngIf=\"lookup\">\n    <div class=\"row mb-4\">\n      <div class=\"col-12 col-sm-10 row ml-0\">\n        <div *ngIf=\"lookup.content?.criteriaBlock?.actions?.lookup; let lookup\"\n          class=\"col-12 col-sm-auto px-0 pr-sm-2 pb-2\">\n          <button base-button class=\"btn btn-outline-primary btn-block\" [field]=\"lookup\"\n            (click)=\"actionTriggered(lookup, true)\">{{lookup.label}}</button>\n        </div>\n        <div *ngIf=\"lookup.content?.criteriaBlock?.actions?.clear; let clear\"\n          class=\"col-12 col-sm-auto px-0 px-sm-2 pb-2\">\n          <button base-button class=\"btn btn-outline-primary btn-block\" [field]=\"clear\"\n            (click)=\"actionTriggered(clear, true)\">{{clear.label}}</button>\n        </div>\n        <div *ngIf=\"lookup.actions?.cancel; let cancel\" class=\"col-12 col-sm-auto px-0 px-sm-2\">\n          <button base-button class=\"btn btn-outline-primary btn-block\" [field]=\"cancel\"\n            (click)=\"cancelLookup(cancel)\">{{cancel.label}}</button>\n        </div>\n      </div>\n      <div *ngIf=\"lookup.actions?.ok; let ok\" class=\"col-12 col-sm-2 row ml-0 px-sm-0 justify-content-end\">\n        <div class=\"col-12 col-sm-auto px-0\">\n          <button base-button [field]=\"ok\" (click)=\"submit(ok)\" class=\"btn btn-primary btn-block\"> Done</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"lookup && !lookup?.content.results && !loading\">\n    {{'ps-ui.lookup.no_matching_values' | translate}}\n  </div>\n\n  <div *ngIf=\"lookup?.content?.results?.rows?.length\" class=\"border-top pt-3 mb-2\">\n    <ui-dynamic-heading [headingLevel]=\"referenceHeading ? 1 : 2\" [style]=\"'sr-only'\">{{'ps-ui.lookup.results_heading' | translate}}</ui-dynamic-heading>\n    <div *ngIf=\"selected?.length\" class=\"mb-3\">\n      <label class=\"font-weight-bold text-uppercase mb-0 mr-1\">{{'ps-ui.lookup.selected' | translate}}:</label>\n      <span [innerText]=\"selected.join(', ')\"></span>\n    </div>\n\n    <ul class=\"list-unstyled list-group\">\n      <li *ngFor=\"let row of lookup.content?.results?.rows; let i=index\" class=\"list-group-item list-group-item-action\"\n        [class.bg-light]=\"row.data[0].checked\">\n        <a *ngIf=\"row.data[0].nodeType === 'a'\" class=\"d-block px-0 py-2 py-md-3 px-md-3\" href=\"javascript:void(0)\"\n          (click)=\"select(i, row, row.data[0].action, $event)\" [title]=\"row.data[0].text || row.data[0].value\">\n          <label [id]=\"'label' + i\" class=\"small text-uppercase text-muted mb-1 mb-md-2\"\n            *ngIf=\"lookup.content?.results?.headings?.data[0]; let header\">\n            {{header.text || header}}\n          </label>\n          <div [attr.aria-labelledby]=\"'label' + i\" class=\"h5 font-weight-bold text-primary mb-1 mb-md-2\">\n            {{row.data[0].text || row.data[0].value}}\n          </div>\n          <div *ngFor=\"let data of row.data | slice: 1; let j = index \">\n            <label class=\"font-weight-bold mr-2 mb-0\"\n              *ngIf=\"lookup.content?.results?.headings?.data[j + 1]; let header\">\n              <ng-container *ngIf=\"header.nodeType === 'a'; else textHeader\">{{header.text}}:</ng-container>\n              <ng-template #textHeader>{{header}}:</ng-template>\n            </label>\n            <a *ngIf=\"data.nodeType === 'a'\" href=\"javascript:void(0)\" (click)=\"select(i, row, data.action, $event)\"\n              [title]=\"data.text || data.value\">\n              <span [innerHTML]=\"data.text || data.value\"></span>\n            </a>\n            <span *ngIf=\"!data.nodeType\">{{data}}</span>\n          </div>\n        </a>\n        <a *ngIf=\"row.data[0].nodeType === 'input'\" class=\"d-flex flex-row px-2 py-2 py-md-3 px-md-3\" role=\"action\"\n          href=\"javascript:void(0)\" (click)=\"include(row.data[0],row.data[1])\"\n          [title]=\"(row.data[0].checked ? 'Remove ' : 'Select ') + row.data[1]?.text || row.data[1]?.value\">\n          <div class=\"d-flex flex-row align-items-center text-muted pr-4 mr-1\">\n            <i class=\"font-weight-bold ifc-icon ifc-check\" [class.text-primary]=\"row.data[0].checked\"></i>\n            <span *ngIf=\"row.data[0].checked\" class=\"sr-only\">{{'ps-ui.lookup.selected' | translate}}</span>\n          </div>\n          <div>\n            <label [id]=\"'label' + i\" class=\"small text-uppercase text-muted mb-1 mb-md-2\"\n              *ngIf=\"lookup.content?.results?.headings?.data[1]; let header\">\n              {{header.text || header}}\n            </label>\n            <div [attr.aria-labelledby]=\"'label' + i\" class=\"h5 font-weight-bold text-primary mb-1 mb-md-2\">\n              {{row.data[1].text || row.data[1].value}}\n            </div>\n            <div *ngFor=\"let data of row.data | slice: 2; let i = index \">\n              <label class=\"font-weight-bold mr-2 mb-0\"\n                *ngIf=\"lookup.content?.results?.headings?.data[i + 2]; let header\">\n                <ng-container *ngIf=\"header.nodeType === 'a'; else textHeader\">{{header.text}}:</ng-container>\n                <ng-template #textHeader>{{header}}:</ng-template>\n              </label>\n              <span>{{data.text || data.value || data}}</span>\n            </div>\n          </div>\n        </a>\n      </li>\n    </ul>\n\n    <div *ngIf=\"lookup.actions?.ok; let ok\" class=\"row mt-3 justify-content-end\">\n      <div class=\"col-12 col-sm-auto\">\n        <button base-button [field]=\"ok\" (click)=\"submit(ok)\" class=\"btn btn-primary btn-block\">{{'ps-ui.lookup.done' | translate}}</button>\n      </div>\n    </div>\n\n    <div class=\"row clearfix mt-3 justify-content-end mx-0\">\n      <div class=\"col-12 col-sm-auto px-0\" *ngIf=\"lookup.content?.criteriaBlock?.actions?.loadMore; let loadmore\">\n        <button base-button class=\"btn btn-primary btn-block\" [field]=\"loadmore\"\n          (click)=\"loadMore(loadmore)\">{{loadmore.label}}</button>\n      </div>\n    </div>\n  </div>\n\n  <ui-hiddens [fields]=\"lookup?.hiddens\" [form]=\"form\"></ui-hiddens>\n"
            }]
    }], function () { return [{ type: ɵngcc6.PsHttp }, { type: ɵngcc2.FormBuilder }, { type: ɵngcc5.LastResponseService }, { type: ɵngcc7.Router }, { type: ɵngcc7.ActivatedRoute }, { type: ɵngcc0.ElementRef }]; }, { inline: [{
            type: Input
        }], cancelClick: [{
            type: Output
        }], valueClick: [{
            type: Output
        }], lookupFailed: [{
            type: Output
        }], referenceHeading: [{
            type: Input
        }], lookupInit: [{
            type: Input
        }] }); })();

function UpdateRelatedCheckboxControl(evt) {
    const el = evt.src;
    const chkel = el;
    const form = evt.args.form;
    const relatedCtrlName = getRelatedName(chkel);
    if (!form.contains(relatedCtrlName)) {
        form.addControl(relatedCtrlName, new FormControl());
    }
    const relatedCtrl = form.controls[relatedCtrlName];
    if (form.contains(chkel.name)) {
        const originalCtrl = form.controls[chkel.name];
        const onValue = chkel.onValue || originalCtrl.value || 'Y';
        const offValue = chkel.offValue || 'N';
        relatedCtrl.setValue(chkel.checked ? onValue : offValue);
        originalCtrl.setValue(chkel.checked ? chkel.value : undefined);
    }
    else if (chkel.offValue !== undefined) {
        relatedCtrl.setValue(chkel.offValue);
    }
}
function getRelatedName(field) {
    if (field.extraAttributes && field.extraAttributes.relatedCtrl) {
        return field.extraAttributes.relatedCtrl;
    }
    else if (field.name.indexOf('$') > -1) {
        return field.name.replace('$', '$chk$');
    }
    else {
        return field.name + '$chk';
    }
}

class PSUINgModule {
    constructor(hooksService) {
        hooksService.onChange
            .pipe(filter((evt) => evt.src.nodeType === 'input' &&
            evt.src.type === 'checkbox'))
            .subscribe(UpdateRelatedCheckboxControl);
    }
    static forRoot() {
        return {
            ngModule: PSUINgModule,
            providers: [
                SessionTimerService
            ]
        };
    }
}
PSUINgModule.ɵfac = function PSUINgModule_Factory(t) { return new (t || PSUINgModule)(ɵngcc0.ɵɵinject(ɵngcc3.HooksService)); };
PSUINgModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PSUINgModule });
PSUINgModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            CoreNg,
            PSCoreNg,
            UINgModule
        ]] });
PSUINgModule.ctorParameters = () => [
    { type: HooksService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PSUINgModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    TranslateModule,
                    CoreNg,
                    PSCoreNg,
                    UINgModule
                ],
                declarations: [
                    LoginComponent,
                    SessionTimerComponent,
                    AddressEditComponent,
                    InputLookupComponent,
                    LookupComponent
                ],
                exports: [
                    LoginComponent,
                    SessionTimerComponent,
                    AddressEditComponent,
                    InputLookupComponent,
                    LookupComponent
                ]
            }]
    }], function () { return [{ type: ɵngcc3.HooksService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PSUINgModule, { declarations: function () { return [LoginComponent, SessionTimerComponent, AddressEditComponent, InputLookupComponent, LookupComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        CoreNg,
        PSCoreNg,
        UINgModule]; }, exports: function () { return [LoginComponent, SessionTimerComponent, AddressEditComponent, InputLookupComponent, LookupComponent]; } }); })();

/*
 * Public API Surface of ps-ui-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressEditComponent, InputLookupComponent, LoginComponent, LookupComponent, PSUINgModule, SessionTimerComponent, SessionTimerService, UpdateRelatedCheckboxControl };

